import { render } from "./FAQMain.vue?vue&type=template&id=5ec789b4"
import script from "./FAQMain.vue?vue&type=script&lang=js"
export * from "./FAQMain.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__